import * as React from "react";

const IconCalendar: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="currentColor"><path fill="currentColor" d="M4.75,0.75 L4.75,0 L3.25,0 L3.25,0.75 L3.25,2 L0,2 L0,4.5 L0,6 L0,14.5 L0,16 L1.5,16 L12.5,16 L14,16 L14,14.5 L14,6 L14,4.5 L14,2 L10.75,2 L10.75,0.75 L10.75,0 L9.25,0 L9.25,0.75 L9.25,2 L4.75,2 L4.75,0.75 Z M1.5,6 L12.5,6 L12.5,14.5 L1.5,14.5 L1.5,6 Z"/></svg>;
};

export default React.memo(IconCalendar);
